import { Question } from "./transactions";

export class Product {
    Id: number;
    Name: string;
    Description: string;
    MetaDescription: string;
    ProductIcon: string;
    Order: number;
    AdditionalData: string;
    Created: string;
    Updated: string;
    Active: boolean;
  }
  export class ProductOption {
    Id: number;
    ProductId: number;
    OptionTitle: string;
    OptionDescription: string;
    BaseOptionPrice: number;
    AvailableTimesToGetProgramInDays: Array<number>;
    PriceForDWGFile: number;
    Created: string;
    Updated: string;
    Active: boolean;
    Order: number;
    IsForOperate: boolean;
    ApartmentSizeTypeTxt: string;
    ApartmentSize: number;
    ExistFileFormat: string;
    IsDefault: boolean;
    WantedFileFormat: string;
    GetDWGFile: boolean;
  }
  
  export class ProductView {
    ProductItem: Product;
    ProductPictureItems: Array<ProductPicture>;
    ProductOptionItems: Array<OptionView>;
  }
  
  export class OptionView {
    ProductOptionItem: ProductOption;
    DayAndPricesItems: Array<DaysPrice>;
    AvailableFileFormatItems: Array<AvailableFileFormat>;
    ExistFileFormatItems: Array<ExistFileFormat>;
    FixesPricesItems: Array<FixesPrices>;
    QuestionsItems: Array<Question>;
    DynamicProductOptions: Array<DynamicProductOptionView>
  }
  
  export class DynamicProductOptionView{
    Id: number;
    OptionId: number;
    OptionTitle: string;
    DynamicProductOptionItems: Array<DynamicProductOptionItem>;
    Created: string;
    Updated: string;
    Active: boolean;
  }
  
  export class DynamicProductOptionItem{
    Id: number;
    DynamicOptionId: number;
    Label: string;
    Price: number;
    Created: string;
    Updated: string;
    Active: boolean;
  }
  export class ProductPicture {
    Id: number;
    ProdId: number;
    Path: string;
    Created: string;
    Updated: string;
    Active: boolean;
  }
  export class DaysPrice {
    Id: number;
    Days: number;
    PricePerDays: number;
    optionId: number;
    IsDefault: boolean;
    Created: string;
    Updated: string;
    Active: boolean;
  }
  export class AvailableFileFormat {
    Id: number;
    FormatName: string;
    optionId: number;
    Price: number;
    IsDefault: boolean;
    Created: string;
    Updated: string;
    Active: boolean;
  }
  export class ExistFileFormat {
    Id: number;
    FormatName: string;
    Price: number;
    optionId: number;
    Created: string;
    IsDefault: boolean;
    Updated: string;
    Active: boolean;
  }
  export class FixesPrices {
    Id: number;
    NumberOfFixes: number;
    Price: number;
    OptionId: number;
    Created: string;
    IsDefault: boolean;
    Updated: string;
    Active: boolean;
  }

  